export const mergeThemes = theme => Object.keys(theme).reduce((themes, publication) => ({
    [publication]: {
        ...theme.default,
        ...theme[publication],
    },
    ...themes,
}), {});
